document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('.cart-drawer');
  const closeBtn = document.querySelector('.cart__close-button');
  const overlay = document.querySelector('.cart-drawer__overlay');

  function openDrawer() {
    drawer.classList.remove('is-closed', 'is-sliding-up');
    drawer.classList.add('is-open');
    drawer.style.display = 'block';
    drawer.style.opacity = '1';
    drawer.style.visibility = 'visible';
    drawer.style.pointerEvents = 'auto';

    void drawer.offsetHeight; // Force reflow
    drawer.scrollTop = 0;
  }

  function closeDrawer() {
    if (!drawer) return;

    drawer.classList.add('is-sliding-up');
    drawer.classList.remove('is-open');

    // Hide overlay immediately
    if (overlay) {
      overlay.style.opacity = '0';
      overlay.style.visibility = 'hidden';
      overlay.style.pointerEvents = 'none';
    }

    // Wait for animation to finish then hide completely
    setTimeout(() => {
      drawer.classList.remove('is-sliding-up');
      drawer.classList.add('is-closed');
      drawer.style.display = 'none';
      drawer.style.opacity = '0';
      drawer.style.visibility = 'hidden';
      drawer.style.pointerEvents = 'none';
    }, 300); // match the CSS animation duration
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      closeDrawer();
    });
  }

  document.body.addEventListener('product:added', () => {
    openDrawer();
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("DOMSubtreeModified", function () {
    const drawer = document.querySelector(".cart-drawer.is-open");
    if (drawer) {
      const header = drawer.querySelector(".cart__header, .cart__close");
      if (header) {
        header.style.display = "block";
        header.style.opacity = "1";
        header.style.visibility = "visible";
        void header.offsetHeight;
      }
    }
  });
});


